import {SET_CAMPAIGNS} from 'actions/types';

var campaignsInitialState = {list:[], indexed:{}, listLoaded:false};
export default (state = campaignsInitialState, action) => {
    switch(action.type) {
        case SET_CAMPAIGNS: 
            return {...state,
                    list:action.campaigns.map((c)=>(c.id)),
                    indexed: action.campaigns.reduce((m,c)=>{m[c.id]=c;return m;},{...state.indexed}),
                    listLoaded:true,
                    count: action.count
                    };
        default:            
            return state;
    }
}

export const isListLoaded = state => state.listLoaded;
export const getCampaigns = state => state.list.map( id => state.indexed[id] );

